import styled from '@emotion/styled'
import { calcRem, colors, fonts, metrics } from '@news-mono/component-library'

export const StyledSite = styled('div')({
    fontFamily: fonts.thewest.body,
    fontSize: metrics.thewest.baseFontSize,
    color: colors.black,
    lineHeight: 1.5,
})

export const SiteFullWidthAd = styled('div')({
    width: '100%',
    background: colors.thewest.greyErmine,
})

export const SiteHeaderAd = styled('div')({
    marginTop: calcRem(-20),
})
